import { useSearchParams } from 'react-router-dom';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { RcmDashboard, type DashboardScenario } from '../RcmDashboard';
import { isDashboardPeriod, type RcmDashboardPeriod } from '../dashboardData';

export function DashboardPage() {
  const [params, setParams] = useSearchParams();

  // Period lives in the URL: ?period=today|week|month (default: this month).
  const rawPeriod = params.get('period');
  const period: RcmDashboardPeriod = isDashboardPeriod(rawPeriod) ? rawPeriod : 'month';

  const rawScenario = params.get('scenario');
  const scenario: DashboardScenario =
    rawScenario === 'loading' || rawScenario === 'error' ? rawScenario : '';

  // Visual redesign direction D: the dashboard renders its own tall PageBand,
  // so suppress the shared compact top bar.
  usePageTopBar({ hideTopBar: true });

  const onPeriodChange = (next: RcmDashboardPeriod) => {
    setParams(
      (prev) => {
        const n = new URLSearchParams(prev);
        n.set('period', next);
        return n;
      },
      { replace: true },
    );
  };

  const onRetry = () => {
    setParams(
      (prev) => {
        const n = new URLSearchParams(prev);
        n.delete('scenario');
        return n;
      },
      { replace: true },
    );
  };

  return (
    <RcmDashboard
      period={period}
      onPeriodChange={onPeriodChange}
      scenario={scenario}
      onRetry={onRetry}
    />
  );
}
